import { render, staticRenderFns } from "./BlockBorder.vue?vue&type=template&id=43093cd4&scoped=true&"
import script from "./BlockBorder.vue?vue&type=script&lang=ts&"
export * from "./BlockBorder.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBorder.vue?vue&type=style&index=0&id=43093cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43093cd4",
  null
  
)

export default component.exports